// src/components/projects/overview/ActivitySection.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import ActivityFeed from '../../activities/ActivityFeed';

const ActivitySection = ({ activities, isLoading, project, loadMoreProjectActivities }) => {
  // Early return if project is null
  if (!project) {
    return null;
  }
  
  return (
  <Box>
    <Typography variant="h6" gutterBottom>
      Recent Activity
    </Typography>
    
    <ActivityFeed
      activities={activities}
      isLoading={isLoading}
      hasMore={activities.length >= 8}
      onLoadMore={() => loadMoreProjectActivities(project._id, { limit: 8 })}
    />
  </Box>
  );
};

export default ActivitySection;